<template>
  <el-card>
    <!--页面顶部标题开始-->
    <div slot="header">
      <h1>"{{form.productName}}" &nbsp; 商品编辑</h1>
    </div>
    <!--页面顶部标题结束-->
    <div class="form-box form-border" style="padding-top: 0;">
      <div class="form-title">基本信息</div>
      <div class="form-content ">
        <div class="form-unit fl">
          <span class="form-key">商品名称：</span>
          <span class="form-value">{{form.productName}}</span>
        </div>

        <div class="form-unit fr">
          <span class="form-key">分类：</span>
          <span class="form-value">{{form.category.cateName}}</span>
        </div>
      </div>
    </div>

    <div class="form-box form-border" style="padding-top: 0;">
      <div class="form-title">详情描述</div>
      <div class="form-content ">
        <MarkdownEditor
          ref="markdownEditor"
          v-model="form.description"
          height="400px"
          sourceType="html"
          :options="{ toolbarItems: [['heading','bold','italic']]}"
        />
      </div>
    </div>

    <div class="form-box">
      <div class="form-title">商品规格</div>

      <el-table class="table" v-loading="loading" :data="form.productSpecs">
        <el-table-column prop="specName" label="规格名称" />
        <el-table-column label="商家编码" >
          <template slot-scope="scope">
            {{scope.row.sku}}
            <el-popover placement="right" @show="copy_sku(scope.row.sku)" content="复制成功">
              <svg-icon icon-class="copy" slot="reference" style="cursor: pointer;" />
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column  prop="price" label="零售价" />
      </el-table>
    </div>

    <div class="form-box" style="text-align: center;">
      <div class="buttons">
        <el-button type="primary" @click="submitForm">保存</el-button>
        <router-link :to="{ name: 'product-product'}">
          <el-button type="default">返回列表</el-button>
          <input type="text" ref="activitySku" id="activitySku" style="display: block;position: absolute;z-index: -10;" v-bind:value="activitySku">
        </router-link>
      </div>
    </div>
  </el-card>
</template>

<script>

  import MarkdownEditor from '@/components/MarkdownEditor'

  export default {
    components: { MarkdownEditor },
    data() {
      return {
        form : {
          category : {},
        },
        loading: false,
        activitySku: '',
      };
    },

    methods : {
      copy_sku(sku) {
        this.activitySku = sku;
        this.$nextTick(() => {
          var activitySku = this.$refs.activitySku;
          activitySku.select(); // 选择对象
          document.execCommand("Copy"); // 执行浏览器复制命令
        })
      },
      async submitForm() {
        const form = _.cloneDeep(this.form)
        const { id, description} = form
        await this.$store.dispatch('products/update', { id, description})
        this.$message.success('商品编辑成功')
        this.$router.push({ name: 'product-product' })
      }

    },

    async mounted() {
      const {id} = this.$route.params;
      const { document } = await this.$store.dispatch('products/document', id);
      this.form = document;
    },
  }
</script>

<style lang="less" scoped>
  @title_color:#373737;
  @value_color:#656565;
  @border_color:#e8e8e8;

  .form-border {
    border-bottom: 1px solid @border_color;
  }
  .form-box {
    overflow: hidden;
    padding: 25px 0;

    .fl {
      float: left;
    }

    .fr {
      float: right;
    }

    .form-strong{
      font-weight: 700;
    }

    .form-title{
      font-size: 18px;
      line-height: 45px;
      color: @title_color;
    }

    .form-unit {
      width: 50%;

      .form-key{
        color: @title_color;
        line-height: 35px;
        display: block;
        min-width: 70px;
        float: left;
      }

      .form-value{
        color: @value_color;
        line-height: 35px;
        float: left;
      }
    }
    .buttons {
      /deep/.el-button {
        margin: 10px;
      }
    }


  }
</style>
<style>
  .el-popover {
    min-width: 10px !important;
  }
</style>
